export async function loadImage(url: string): Promise<HTMLImageElement>
{
    let img = new Image();
    return new Promise((resolve, reject) => {
        img.onload = () => resolve(img);
        img.onerror = reject;
        img.src = url;
    });
}
